export default __webpack_public_path__ + "static/media/34k.17ee0fe2.md";